import { Component, Vue } from "vue-property-decorator";
import { LoadingModule } from "@/store/loading";
import { Result } from "@bit/planetadeleste.shopaholic.types.base";
import { ResponseError } from "@bit/planetadeleste.shopaholic.types.api";

import VueI18n from "vue-i18n";

@Component
export default class GlobalMixin extends Vue {
  responseErrors: ResponseError = {
    error: [],
  };

  get isLoading(): boolean {
    return LoadingModule.getLoading;
  }

  loaded(): void {
    LoadingModule.loaded();
  }

  loading(attach?: string): void {
    LoadingModule.loading(attach);
  }

  setLoading(close = false, attach?: string): void {
    if (close) {
      this.loaded();
    } else {
      this.loading(attach);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processError(error: any): void {
    this.syncErrors(error);
    let message = this.getError("error", "Network error");

    if (message === "invalid_credentials") {
      message = "Usuario/Email o clave incorrectos";
    }

    this.setLoading(true);
    if (message) {
      this.flashError(message);
    }
  }

  flashSuccess(message: string | VueI18n.TranslateResult): void {
    this.$toast.success(message);
  }

  flashError(message: string | VueI18n.TranslateResult): void {
    this.$toast.error(message);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  syncErrors(error: any): boolean {
    if (this.$_.isUndefined(error)) {
      return true;
    }

    if (error instanceof Error) {
      const message: string = error.message;
      if (this.isJSON(message)) {
        return this.syncErrors(JSON.parse(message));
      }

      this.responseErrors.error = [message];
    } else if (
      !this.$_.isUndefined(error.response) &&
      this.$_.has(error, "response") &&
      this.$_.has(error.response, "data")
    ) {
      if (this.$_.has(error.response.data, "errors")) {
        this.responseErrors = error.response.data.errors;
      } else if (this.$_.has(error.response.data, "error")) {
        this.responseErrors.error = [error.response.data.error];
      }
    } else if (this.$_.has(error, "message")) {
      this.responseErrors.error = [error.message];
    } else if (this.$_.has(error, "error")) {
      this.responseErrors.error = [error.error];
    }

    return this.responseErrors.error.length > 0;
  }

  clearErrors(): void {
    this.responseErrors = { error: [] };
  }

  hasErrors(sField: string): boolean {
    return this.$_.has(this.responseErrors, sField);
  }

  getError<T>(sField: string, sDefault: T | null = null): T | null {
    const sMessage: T | null | undefined = this.hasErrors(sField)
      ? this.$_.first(this.$_.get(this.responseErrors, sField))
      : sDefault;

    return sMessage ? sMessage : sDefault;
  }

  getErrors(sField: string): Array<any> | null {
    return this.hasErrors(sField)
      ? this.$_.get(this.responseErrors, sField)
      : null;
  }

  isJSON(str: string): boolean {
    try {
      return JSON.parse(str) && !!str;
    } catch (e) {
      return false;
    }
  }

  tr(key: VueI18n.Path, values?: VueI18n.Values): string {
    const name = this.slugify(key);
    const msg = this.$t(name, values);
    if (this.$_.isString(msg)) {
      return msg;
    }

    return key;
  }

  slugify(key: string): string {
    return this.$_.chain(key).trim().kebabCase().replace(/-/g, ".").value();
  }

  evalResponse(response: Result | any | undefined): void {
    if (!response) {
      return;
    }

    if (response.message) {
      if (response.status) {
        this.flashSuccess(response.message);
      } else {
        this.flashError(response.message);
      }
    }
  }
}
